import React, { useState } from 'react';
import ImageUploader from './ImageUploader'; // your uploader component
import { db } from '../FirebaseConfig'; // your Firebase setup
import { collection, doc, setDoc, serverTimestamp } from 'firebase/firestore';

const UploadProduct = () => {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [imageURL, setImageURL] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !price || !category || !imageURL) {
      return alert("Fill all fields");
    }

    setLoading(true);
    try {
      // Step 1: Create a reference for the new document
      const productRef = doc(collection(db, 'products'));
      const productId = productRef.id;

      // Step 2: Set the document with productId included
      await setDoc(productRef, {
        productId,
        name,
        price,
        category,
        image: imageURL,
        createdAt: serverTimestamp(),
      });

      alert("Product uploaded successfully ✅");

      // Reset form
      setName('');
      setPrice('');
      setCategory('');
      setImageURL('');
    } catch (err) {
      console.error("Error uploading product:", err);
      alert("Failed to upload product");
    }
    setLoading(false);
  };

  return (
    <div className='max-w-lg mx-auto p-4 shadow-lg bg-white rounded-lg space-y-4 mt-10'>
      <h2 className='text-2xl font-bold text-center'>Upload Product</h2>
      <form onSubmit={handleSubmit} className='space-y-4 text-black'>
        <input
          type="text"
          placeholder="Product Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className='w-full border px-3 py-2 rounded'
        />
        <input
          type="number"
          placeholder="Price"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className='w-full border px-3 py-2 rounded'
        />
        <input
          type="text"
          placeholder="Category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className='w-full border px-3 py-2 rounded'
        />
        <ImageUploader onUpload={setImageURL} />
        <button
          type="submit"
          disabled={loading}
          className='w-full bg-green-600 text-white py-2 rounded font-semibold hover:bg-green-700'
        >
          {loading ? 'Uploading...' : 'Upload Product'}
        </button>
      </form>
    </div>
  );
};

export default UploadProduct;
